import styled from "styled-components";

export const ButtonsRow = styled.div`
  display: flex;
  gap: 8px;

  & button {
    flex: 0 0 auto;
    height: 67px;
    padding: 0 40px;
    margin-right: 0;
    font-size: 16px;
    border-radius: 5px;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    flex-direction: column;
    align-items: stretch;

    & button {
      width: 100%;
      height: 40px;
      padding: 0 12px;
      font-size: 14px;
    }
  }
`;
